import React, { useState, useEffect } from 'react';
import Slidebar from './Slidebar';
import apiInstance from '../../utils/axios';
import Swal from 'sweetalert2';
import UserData from '../plugin/UserData';
import moment from 'moment';


function CustomerNotifications() {
    
    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchNotifications = () => {
        if (UserData()?.user_id) {
            apiInstance.get(`customer/notification/${UserData().user_id}/`).then((res) => {
                setNotifications(res.data);
                setLoading(false);
            }).catch((error) => {
                console.error('Error fetching notifications:', error);
                setLoading(false);
            });
        }
    }

    useEffect(() => {
        fetchNotifications()
    }, [])

    const MarkNotificationsAsSeen = (notification_id) => {
        apiInstance.get(`customer/notification/${UserData().user_id}/${notification_id}/`).then((res) => {
            // Remove the notification from the local state
            setNotifications(prevNotifications => 
                prevNotifications.filter(notification => notification.id !== notification_id)
            );
            
            // Show success message
            Swal.fire({
                icon: 'success',
                title: "Notificación marcada como vista",
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        }).catch((error) => {
            console.error('Error marking notification as seen:', error);
            Swal.fire({
                icon: 'error',
                title: "Error",
                text: "Error al marcar la notificación como vista",
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        });
    }

    if (loading) {
        return (
            <div className="container text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
                <p className="mt-3">Cargando notificaciones...</p>
            </div>
        );
    }

    return (
        <div className="customer-dashboard">
            <main className="mt-4 mt-md-5">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 d-md-none">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="mb-0">
                                    <i className="fas fa-bell text-primary" /> Notificaciones
                                    {notifications.length > 0 && (
                                        <span className="badge bg-primary ms-2">{notifications.length}</span>
                                    )}
                                </h3>
                                <button 
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => fetchNotifications()}
                                    title="Actualizar notificaciones"
                                >
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                            </div>
                        </div>
                        
                        <Slidebar />

                        <div className="col-lg-9 col-md-12">
                            <div className="d-none d-md-flex justify-content-between align-items-center mb-4">
                                <h3 className="mb-0">
                                    <i className="fas fa-bell text-primary" /> Notificaciones{" "}
                                    {notifications.length > 0 && (
                                        <span className="badge bg-primary ms-2">{notifications.length}</span>
                                    )}
                                </h3>
                                <button 
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => fetchNotifications()}
                                    title="Actualizar notificaciones"
                                >
                                    <i className="fas fa-sync-alt me-2"></i> Actualizar
                                </button>
                            </div>
                            
                            {notifications.length > 0 ? (
                                <div className="row g-3">
                                    {notifications.map((n, index) => (
                                        <div key={n.id} className="col-12">
                                            <div className="card border-0 shadow-sm h-100 depth-2 fade-in">
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-start">
                                                        <div className="d-flex align-items-center justify-content-center me-3" style={{ 
                                                            width: "50px", 
                                                            height: "50px", 
                                                            backgroundColor: "#e8f5e8", 
                                                            borderRadius: "12px" 
                                                        }}>
                                                            <i className="fas fa-check-circle text-success fs-5"></i>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                <h6 className="mb-1 text-dark fw-semibold">¡Pedido Confirmado!</h6>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-success btn-sm" 
                                                                    onClick={() => MarkNotificationsAsSeen(n.id)} 
                                                                >
                                                                    <i className="fas fa-check me-1"></i> Marcar como visto
                                                                </button>
                                                            </div>
                                                            <p className="mb-2 text-muted">
                                                                Tu pedido ha sido confirmado y está siendo procesado. Recibirás actualizaciones sobre el estado de tu pedido.
                                                            </p>
                                                            <div className="d-flex align-items-center text-muted small">
                                                                <i className="fas fa-clock me-2"></i>
                                                                {moment(n.date).format("MMM D, YYYY [at] h:mm A")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="card border-0 shadow-sm depth-2">
                                    <div className="card-body empty-state">
                                        <div className="empty-state-icon">
                                            <i className="fas fa-bell-slash fa-2x"></i>
                                        </div>
                                        <h5 className="mb-2 text-dark">Sin notificaciones</h5>
                                        <p className="text-muted mb-0">¡Estás al día! Vuelve más tarde para ver actualizaciones.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default CustomerNotifications;